import { Image, theme } from 'antd';
import { type CSSProperties, type FC, useEffect, useState } from 'react';

const BLANK_PROFILE = 'https://static-cdn.racemap.com/img/blank_profile.png';

async function sha256Hex(value: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));

  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export const UserAvatar: FC<{
  email?: string;
  style?: CSSProperties;
  rounded?: boolean;
}> = ({ email, style = {}, rounded = true }) => {
  const { token } = theme.useToken();
  const [imageSrc, setImageSrc] = useState(BLANK_PROFILE);

  useEffect(() => {
    if (email == null) {
      setImageSrc(BLANK_PROFILE);
      return;
    }

    let cancelled = false;
    // Gravatar accepts the sha256 of the trimmed, lowercased address. Hashing is
    // async because the Web Crypto API has no synchronous digest.
    void sha256Hex(email.trim().toLowerCase()).then((emailHash) => {
      if (!cancelled) {
        setImageSrc(`https://www.gravatar.com/avatar/${emailHash}?s=50&d=${BLANK_PROFILE}`);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [email]);

  const imageStyle = {
    borderRadius: rounded ? token.borderRadiusLG : 0,
    width: 50,
    height: 50,
    ...style,
  };

  return <Image src={imageSrc} alt="Profile Pic" style={imageStyle} />;
};
